import {
  asistenteCargaMasiva, columnasRevision, conteoPor, escapar, filaResumen, menuArchivos, menuOpciones,
  nota, notas, rangoFechas,
} from "./dialogos_carga_masiva";
import { descargarPlantillaVisitantes, leerArchivoVisitantes, cambiosPaseCargado } from "../../functions/importar_visitantes";
import { exportarCSV, guardarCambiosMasivos } from "../../functions/importar_masivo";
import { dialogo } from "./dialogos_cartera";
import { TIPOS_CON_HISTORIAL } from "../../functions/pase_visitante";
import { opcionEliminar } from "./listado_comun";

// Ventanas de visitantes: menú de archivos, menú de opciones de cada fila y carga desde Excel.

export const menuArchivosVisitantes = ({ puedeCargar }) => menuArchivos({
  titulo: "Archivos de visitantes",
  plural: "visitantes",
  detalleExportar: "Descarga en Excel (CSV) los pases que se ven en la tabla.",
  detallePlantilla: "Archivo de Excel con ejemplos para llenar los pases de visitantes.",
  detalleCargar: "Registra muchos pases de una vez desde la plantilla llena.",
  puedeCargar,
});

// puedeFacturar: solo portería y si el conjunto tiene el módulo de parqueadero.
// puedeEnviarCorreo: residente, administrador o super, como "Enviar correo evento" en la app.
// puedeGestionar: como en la app (detalle_pase.dart → _puedeGestionar), solo portería registra ingresos y salidas.
export const menuAccionesVisitante = ({ visitante, puedeGestionar, puedeFacturar, puedeEnviarCorreo }) => menuOpciones({
  icono: "bi-person-badge",
  titulo: "Acciones del pase",
  texto: `<strong>${escapar(visitante.nombreDocumentoVisitante || "Visitante")}</strong>${visitante.casa ? ` · ${escapar(visitante.casa)}` : ""}<br>Estado: ${escapar(visitante.estado || "Sin estado")}`,
  opciones: [
    ...(puedeGestionar ? [
      { clave: "gestionar", icono: "bi-pencil", nombre: "Gestionar pase",
        detalle: visitante.estado === "Anulado"
          ? "Este pase está anulado y ya no se puede modificar."
          : "Registre el ingreso o la salida, anule el pase o cambie los datos del vehículo." },
    ] : []),
    ...(TIPOS_CON_HISTORIAL.includes(visitante.tipoPermiso) ? [
      { clave: "historial", icono: "bi-clock-history", nombre: "Ver historial",
        detalle: "Todos los ingresos y salidas de este pase, con la fecha y quién autorizó." },
    ] : []),
    ...(puedeFacturar ? [
      { clave: "factura", icono: "bi-receipt", nombre: "Generar factura",
        detalle: "Calcule el cobro del parqueadero y envíe el recibo." },
    ] : []),
    ...(puedeEnviarCorreo ? [
      { clave: "correo", icono: "bi-envelope", nombre: "Enviar correo evento",
        detalle: "Envíe el pase con el código QR al correo del visitante." },
    ] : []),
    opcionEliminar("este pase y su historial"),
  ],
});

const MOVIMIENTOS_VISIBLES = 8;
const ICONO_MOVIMIENTO = { Ingreso: "bi-box-arrow-in-right", Salida: "bi-box-arrow-right", Anulado: "bi-x-circle" };

// Historial de un pase PERMANENTE o LIMITADO: totales a la izquierda y los últimos movimientos a la
// derecha. movimientos viene de movimientosHistorial (más reciente primero); se puede descargar completo.
export const historialPase = async (visitante, movimientos) => {
  const nombre = visitante.nombreDocumentoVisitante || "Visitante";
  const texto = `<strong>${escapar(nombre)}</strong>${visitante.casa ? ` · ${escapar(visitante.casa)}` : ""}<br>Pase ${escapar(visitante.tipoPermiso || "")}`;
  if (!movimientos.length) {
    return dialogo({ icono: "bi-clock-history", titulo: "Historial del pase", texto,
      contenido: nota("info", "bi-info-circle", "Este pase todavía no tiene ingresos ni salidas registrados."), confirmar: "Cerrar" });
  }
  const cuantos = (estado) => movimientos.filter(m => m.estado === estado).length;
  const ultimo = movimientos[0];
  const totales = [
    filaResumen("bi-list-ol", "Movimientos", movimientos.length),
    filaResumen("bi-box-arrow-in-right", "Ingresos", cuantos("Ingreso")),
    filaResumen("bi-box-arrow-right", "Salidas", cuantos("Salida")),
    filaResumen("bi-clock", "Último", `${escapar(ultimo.estado)} · ${escapar(ultimo.fechaTexto)}`),
  ].join("");
  const recientes = movimientos.slice(0, MOVIMIENTOS_VISIBLES).map(m =>
    filaResumen(ICONO_MOVIMIENTO[m.estado] || "bi-dot", escapar(m.estado), `${escapar(m.fechaTexto)}<br><small>Autorizó: ${escapar(m.autorizo)}</small>`)).join("");
  const faltan = movimientos.length - MOVIMIENTOS_VISIBLES;

  const { isConfirmed } = await dialogo({
    amplio: true,
    cerrar: true,
    icono: "bi-clock-history",
    titulo: "Historial del pase",
    texto,
    contenido: `<div class="cartera-columnas">
      <div><p class="cartera-subtitulo">Resumen</p><div class="cartera-lista">${totales}</div></div>
      <div><p class="cartera-subtitulo">${faltan > 0 ? `Últimos ${MOVIMIENTOS_VISIBLES}` : "Movimientos"}</p><div class="cartera-lista">${recientes}</div></div>
    </div>${faltan > 0 ? nota("info", "bi-download", `Hay ${faltan} movimientos más antiguos. Descargue el historial completo para verlos todos.`) : ""}`,
    confirmar: "Descargar historial",
    iconoConfirmar: "bi-download",
    cancelar: "Cerrar",
  });
  if (isConfirmed) {
    exportarCSV(
      [{ label: "Fecha", key: "fechaTexto" }, { label: "Movimiento", key: "estado" }, { label: "Autorizó", key: "autorizo" }],
      movimientos,
      `historial_${nombre.replace(/[^\w]+/g, "_")}.csv`,
    );
  }
};

// Devuelve true si se guardaron pases.
export const asistenteCargarVisitantes = () => asistenteCargaMasiva({
  t: {
    icono: "bi-people",
    titulo: "Cargar visitantes desde Excel",
    texto: "Registre muchos pases de visitantes de una sola vez con un archivo de Excel (.xlsx) o CSV.",
    notaColumnas: "Tiene las mismas columnas que la tabla y tres más al final. Son obligatorias <strong>DIRECCIÓN</strong>, <strong>NOMBRE INVITADO</strong> y <strong>N° DOCUMENTO</strong>; si el visitante ya salió, también <strong>FECHA SALIDA</strong>.",
    faltanColumnas: "<strong>DIRECCIÓN</strong> y <strong>NOMBRE INVITADO</strong>",
    filaVacia: "Escriba debajo un visitante por fila.",
    uno: "pase",
    varios: "pases",
    ninguno: "ningún pase",
    exito: "Pases cargados",
  },
  descargarPlantilla: descargarPlantillaVisitantes,
  leer: (archivo) => leerArchivoVisitantes(archivo),
  guardar: (registros) => guardarCambiosMasivos(registros, cambiosPaseCargado),
  revision: (nombreArchivo, { registros, ejemplos }) => columnasRevision([
    filaResumen("bi-file-earmark-spreadsheet", "Archivo", escapar(nombreArchivo)),
    filaResumen("bi-people", "Pases", registros.length),
    filaResumen("bi-houses", "Viviendas", new Set(registros.map(r => r.vivienda)).size),
    filaResumen("bi-card-checklist", "Tipo de pase", conteoPor(registros, "tipoPermiso")),
    filaResumen("bi-tag", "Estados", conteoPor(registros, "estado")),
    filaResumen("bi-calendar-date", "Fecha de creación", rangoFechas(registros.map(r => r.creacion.fecha))),
  ], ejemplos) + notas(
    nota("info", "bi-info-circle",
      "Los pases en Pendiente o Ingreso se gestionan después con el botón Opciones. Los que traen fecha de salida quedan en <strong>Salida</strong>."),
  ),
});
